import { Button } from "@chakra-ui/button";
import { Box, Center, Grid, GridItem, Heading, Stack, Text } from "@chakra-ui/layout";
import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay, FormControl, FormLabel, IconButton, Input, InputGroup,
  InputRightAddon, Menu, Icon, Flex,
  MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Tab, TabList, TabPanel, TabPanels, Tabs, theme, useColorModeValue, useDisclosure, Wrap
} from "@chakra-ui/react";


import Tweets from "components/tweets";

import { useRouter } from "next/dist/client/router";
import React, { useContext, useEffect } from "react";

import { AddIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { useSession } from "next-auth/react";

import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { UpsertCollection } from "components/collection-upsert";
import ProtectedRoute from "components/protected-route";
import { deleteList, getList } from "controllers/bookmark";
import { getCollection } from "controllers/staticCollection";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast from "react-hot-toast";
import { BiCopy, BiShuffle } from 'react-icons/bi';
// import useSWR, { mutate } from "swr";
import { Page } from "components/page";
import { ImportTweet } from "components/popups/importTweet";
import PuffLoader from "react-spinners/PuffLoader";
import { MainContext } from "../context/mainContext";
import * as analytics from "../utils/analytics";
import { setInLocalStorage } from "../utils/helpers";
import { getAccount } from "../utils/sessionHelper";
import { useFirebaseUser } from "../utils/useFirebaseUser";
import { ModalInfoIcon } from "components/popups/ModalInfoIcon";
import { color, textStyle, variant } from "theme/names";
import { TweetContext } from "context/tweetContext";

const selectedTabStyle = { 
  borderBottom: "solid 2px" + theme.colors.blue[300],
  color: theme.colors.blue[300],
};

const staticCollections = [
  // {title: "all", name: "all"},
  // {title: "💪 fitness & nutrition", name: "fitness & nutrition"},
  // {title: "🤝 relationships", name: "relationships"},
  // {title: "🔥 sales tweets", name: "sales tweets"},
  // {title: "⛔ the system is wrong", name: "the system is wrong"},
  // {title: "🧵 thread starters", name: "thread starters"},
  {
    icon: (
      <Icon
      viewBox="0 0 15 16"
      >
        <svg
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 7C7.8125 7 8.5 6.34375 8.5 5.5C8.5 4.6875 7.8125 4 7 4C6.15625 4 5.5 4.6875 5.5 5.5C5.5 6.34375 6.15625 7 7 7ZM8 8H6C5.15625 8 4.5 8.6875 4.5 9.5V12C4.5 12.5625 4.9375 13 5.5 13V15C5.5 15.5625 5.9375 16 6.5 16H7.5C8.03125 16 8.5 15.5625 8.5 15V13C9.03125 13 9.5 12.5625 9.5 12V9.5C9.5 8.6875 8.8125 8 8 8ZM8 11.5H6V9.5H8V11.5ZM11 4C12.0938 4 13 3.125 13 2C13 0.90625 12.0938 0 11 0C9.875 0 9 0.90625 9 2C9 3.125 9.875 4 11 4ZM3 4C4.09375 4 5 3.125 5 2C5 0.90625 4.09375 0 3 0C1.875 0 1 0.90625 1 2C1 3.125 1.875 4 3 4ZM1.5 7C1.5 6.75 1.71875 6.5 2 6.5H4.71875C4.5625 6.21875 4.5 5.875 4.5 5.5C4.5 5.375 4.5 5.25 4.53125 5.09375C4.34375 5.0625 4.1875 5 4 5H2C0.875 5 0 5.90625 0 7V10C0 10.5625 0.4375 11 1 11V15.25C1 15.6875 1.3125 16 1.75 16C2.15625 16 2.5 15.6875 2.5 15.25V11H3.5V9.5H1.5V7ZM14.7812 10.75L13.5625 6.46875C13.3125 5.59375 12.5312 5 11.625 5H10.3438C10 5 9.71875 5.125 9.46875 5.25C9.46875 5.34375 9.5 5.40625 9.5 5.5C9.5 5.875 9.40625 6.21875 9.25 6.5H11.625C11.875 6.5 12.0625 6.65625 12.125 6.875L13.1562 10.5H10.5V12H11.5V15.25C11.5 15.6875 11.8125 16 12.25 16C12.6562 16 13 15.6875 13 15.25V12H13.8125C14.5 12 14.9688 11.375 14.7812 10.75Z"
            fill="currentColor"
          />
        </svg>
      </Icon>
    ),
    title: "family",
    name: "family",
  },
  {
    icon: (
      <Icon
      viewBox="0 0 16 16"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 4.0625C6.125 4.09375 6.25 4.125 6.375 4.15625C6.625 4.21875 6.78125 4.5 6.71875 4.78125C6.65625 5.03125 6.375 5.1875 6.09375 5.125C5.84375 5.0625 5.53125 5 5.25 5.03125C5.125 5.03125 5.0625 5.0625 5.03125 5.09375C4.96875 5.15625 4.96875 5.25 5.03125 5.3125C5.25 5.46875 5.5 5.53125 5.75 5.59375C6.03125 5.65625 6.28125 5.75 6.5 5.90625C6.65625 6 6.8125 6.15625 6.90625 6.34375C7 6.5625 7 6.78125 6.96875 7C6.90625 7.375 6.71875 7.65625 6.4375 7.8125C6.28125 7.90625 6.125 7.96875 6 8V8.25C6 8.53125 5.75 8.75 5.5 8.75C5.21875 8.75 5 8.53125 5 8.25V7.9375C4.71875 7.875 4.5 7.78125 4.3125 7.75C4.0625 7.65625 3.9375 7.375 4 7.09375C4.09375 6.84375 4.375 6.6875 4.65625 6.78125C4.9375 6.875 5.3125 7 5.65625 7C5.8125 7 5.875 7 5.90625 6.96875C6 6.90625 6.03125 6.78125 5.9375 6.71875C5.8125 6.625 5.65625 6.59375 5.34375 6.5H5.3125C5.0625 6.40625 4.71875 6.3125 4.46875 6.125C4.3125 6.03125 4.15625 5.875 4.0625 5.6875C3.96875 5.46875 3.96875 5.25 4 5.03125C4.0625 4.6875 4.21875 4.4375 4.46875 4.28125C4.625 4.15625 4.8125 4.09375 5 4.0625V3.75C5 3.5 5.21875 3.25 5.5 3.25C5.75 3.25 6 3.5 6 3.75V4.0625ZM10.5 3.25C10.75 3.25 11 3.5 11 3.75V4.0625C11.125 4.09375 11.25 4.125 11.375 4.15625C11.625 4.21875 11.7812 4.5 11.7188 4.78125C11.6562 5.03125 11.375 5.1875 11.0938 5.125C10.8438 5.0625 10.5312 5 10.25 5.03125C10.125 5.03125 10.0625 5.0625 10.0312 5.09375C9.96875 5.15625 9.96875 5.25 10.0312 5.3125C10.25 5.46875 10.5 5.53125 10.75 5.59375C11.0312 5.65625 11.2812 5.75 11.5 5.90625C11.6562 6 11.8125 6.15625 11.9062 6.34375C12 6.5625 12 6.78125 11.9688 7C11.9062 7.375 11.7188 7.65625 11.4375 7.8125C11.2812 7.90625 11.125 7.96875 11 8V8.25C11 8.53125 10.75 8.75 10.5 8.75C10.2188 8.75 10 8.53125 10 8.25V7.9375C9.71875 7.875 9.5 7.78125 9.3125 7.75C9.0625 7.65625 8.9375 7.375 9 7.09375C9.09375 6.84375 9.375 6.6875 9.65625 6.78125C9.9375 6.875 10.3125 7 10.6562 7C10.8125 7 10.875 7 10.9062 6.96875C11 6.90625 11.0312 6.78125 10.9375 6.71875C10.8125 6.625 10.6562 6.59375 10.3438 6.5H10.3125C10.0625 6.40625 9.71875 6.3125 9.46875 6.125C9.3125 6.03125 9.15625 5.875 9.0625 5.6875C8.96875 5.46875 8.96875 5.25 9 5.03125C9.0625 4.6875 9.21875 4.4375 9.46875 4.28125C9.625 4.15625 9.8125 4.09375 10 4.0625V3.75C10 3.5 10.2188 3.25 10.5 3.25ZM8.34375 11.3438C8.4375 11.375 8.53125 11.4062 8.625 11.4062C8.8125 11.4688 8.9375 11.6562 8.875 11.8438C8.84375 12.0625 8.625 12.1562 8.4375 12.125C8.21875 12.0625 7.96875 12.0312 7.78125 12.0312C7.6875 12.0625 7.65625 12.0625 7.625 12.0938C7.5625 12.125 7.5625 12.2188 7.625 12.25C7.78125 12.375 7.96875 12.4062 8.15625 12.4688C8.375 12.5 8.5625 12.5625 8.71875 12.6875C8.84375 12.75 8.9375 12.8438 9.03125 13C9.09375 13.1562 9.09375 13.3125 9.0625 13.5C9.03125 13.75 8.875 13.9688 8.65625 14.0938C8.5625 14.1562 8.4375 14.1875 8.34375 14.1875V14.4062C8.34375 14.5938 8.15625 14.75 7.96875 14.75C7.75 14.75 7.59375 14.5938 7.59375 14.4062V14.1562C7.375 14.125 7.21875 14.0625 7.09375 14.0312C6.90625 13.9688 6.78125 13.75 6.84375 13.5625C6.90625 13.375 7.125 13.25 7.3125 13.3438C7.5625 13.4062 7.84375 13.5 8.0625 13.5C8.1875 13.5 8.25 13.4688 8.28125 13.4688C8.34375 13.4062 8.34375 13.3125 8.3125 13.2812C8.21875 13.2188 8.09375 13.1875 7.84375 13.125V13.0938C7.65625 13.0625 7.375 12.9688 7.1875 12.8438C7.09375 12.7812 6.96875 12.6562 6.90625 12.5312C6.84375 12.375 6.8125 12.2188 6.84375 12.0312C6.90625 11.8125 7 11.625 7.1875 11.5C7.3125 11.4062 7.4375 11.375 7.59375 11.3438V11.125C7.59375 10.9375 7.75 10.75 7.96875 10.75C8.15625 10.75 8.34375 10.9375 8.34375 11.125V11.3438ZM0 8C0 3.59375 3.5625 0 8 0C12.4062 0 16 3.59375 16 8C16 12.4375 12.4062 16 8 16C3.5625 16 0 12.4375 0 8ZM10.875 13.8438C13 12.7812 14.5 10.5625 14.5 8C14.5 4.4375 11.5625 1.5 8 1.5C4.40625 1.5 1.5 4.4375 1.5 8C1.5 10.5625 2.96875 12.7812 5.09375 13.8438C5.03125 13.5938 5 13.3438 5 13.0938C4.03125 12.4062 3.3125 11.4688 3 10.3438C2.875 9.90625 3.25 9.5 3.6875 9.5H12.2812C12.7188 9.5 13.0938 9.90625 12.9688 10.3438C12.6562 11.4688 11.9375 12.4062 10.9688 13.0938C10.9688 13.3438 10.9375 13.5938 10.875 13.8438ZM9.46875 14.3438C9.65625 14.1562 9.78125 13.9062 9.875 13.6562C9.9375 13.4688 10 13.25 10 13V10.5H6V13C6 13.25 6.03125 13.4688 6.09375 13.6562C6.1875 13.9062 6.3125 14.1562 6.5 14.3438C6.84375 14.75 7.375 15 8 15C8.59375 15 9.125 14.75 9.46875 14.3438Z"
            fill="currentColor"
          />
        </svg>
      </Icon>
    ),
    title: "make money online",
    name: "make money online",
  },
  {
    icon: (
      <Icon
      viewBox="0 0 16 14"
      >
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 11.75C1.5 12.1875 1.8125 12.5 2.25 12.5H15.25C15.6562 12.5 16 12.8438 16 13.25C16 13.6875 15.6562 14 15.25 14H2.25C1 14 0 13 0 11.75V0.75C0 0.34375 0.3125 0 0.75 0C1.15625 0 1.5 0.34375 1.5 0.75V11.75ZM10.75 3H14.25C14.6562 3 15 3.34375 15 3.75V7.25C15 7.6875 14.6562 8 14.25 8C13.8125 8 13.5 7.6875 13.5 7.25V5.5625L10 9.03125C9.71875 9.34375 9.25 9.34375 8.96875 9.03125L6.46875 6.5625L4.5 8.53125C4.21875 8.84375 3.75 8.84375 3.46875 8.53125C3.15625 8.25 3.15625 7.78125 3.46875 7.46875L5.96875 4.96875C6.25 4.6875 6.71875 4.6875 7 4.96875L9.5 7.46875L12.4375 4.5H10.75C10.3125 4.5 10 4.1875 10 3.75C10 3.34375 10.3125 3 10.75 3Z"
            fill="currentColor"
          />
        </svg>
      </Icon>
    ),
    title: "marketing & sales",
    name: "marketing & sales",
  },
  {
    icon: (
      <Icon
      viewBox="0 0 16 16"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.625 7.21875C8.8125 7.25 9.125 7.3125 9.28125 7.34375C9.59375 7.4375 9.8125 7.78125 9.71875 8.125C9.625 8.4375 9.28125 8.65625 8.9375 8.5625C8.84375 8.53125 8.40625 8.4375 8.28125 8.40625C7.875 8.375 7.5625 8.40625 7.375 8.5C7.1875 8.59375 7.125 8.6875 7.125 8.75C7.09375 8.875 7.125 8.90625 7.125 8.90625C7.125 8.9375 7.15625 8.96875 7.25 9.03125C7.4375 9.15625 7.71875 9.25 8.15625 9.375H8.1875C8.5625 9.5 9.09375 9.65625 9.46875 9.9375C9.65625 10.0938 9.875 10.2812 10 10.5625C10.125 10.8438 10.125 11.1562 10.0938 11.5C9.96875 12.0938 9.59375 12.5 9.09375 12.6875C8.9375 12.75 8.78125 12.8125 8.625 12.8438V13C8.625 13.375 8.34375 13.6562 7.96875 13.6562C7.625 13.6562 7.34375 13.375 7.34375 13V12.8125C7.0625 12.75 6.65625 12.625 6.4375 12.5312C6.375 12.5 6.3125 12.5 6.28125 12.4688C5.96875 12.375 5.78125 12.0312 5.90625 11.6875C6 11.375 6.34375 11.1875 6.6875 11.2812C6.75 11.3125 6.8125 11.3438 6.875 11.375C7.1875 11.4688 7.5 11.5625 7.6875 11.5938C8.09375 11.6562 8.40625 11.625 8.59375 11.5625C8.78125 11.4688 8.84375 11.375 8.84375 11.2812C8.875 11.1562 8.84375 11.0938 8.84375 11.0625C8.84375 11.0312 8.8125 11 8.71875 10.9375C8.53125 10.8125 8.25 10.7188 7.8125 10.5625H7.75C7.375 10.4375 6.90625 10.3125 6.53125 10.0625C6.34375 9.90625 6.125 9.71875 6 9.4375C5.875 9.15625 5.84375 8.84375 5.875 8.53125C6 7.96875 6.40625 7.5625 6.875 7.375C7 7.28125 7.1875 7.25 7.34375 7.1875V7C7.34375 6.65625 7.625 6.375 8 6.375C8.34375 6.375 8.625 6.65625 8.625 7V7.21875ZM5.59375 3.78125L3.78125 1.1875C3.4375 0.6875 3.8125 0 4.40625 0H11.5625C12.1562 0 12.5312 0.6875 12.1875 1.1875L10.375 3.78125C10.6562 3.9375 10.9375 4.15625 11.2812 4.375C13.1875 5.8125 16 8.59375 16 13C16 14.6562 14.6562 16 13 16H3C1.3125 16 0 14.6562 0 13C0 8.59375 2.78125 5.8125 4.6875 4.375C5.03125 4.15625 5.3125 3.9375 5.59375 3.78125ZM6.375 5.03125C4.6875 6.125 1.5 8.65625 1.5 13C1.5 13.8438 2.15625 14.5 3 14.5H13C13.8125 14.5 14.5 13.8438 14.5 13C14.5 8.65625 11.2812 6.125 9.59375 5.03125L9.15625 4.75H6.8125L6.375 5.03125ZM8.90625 3.25L10.125 1.5H5.84375L7.0625 3.25H8.90625Z"
            fill="currentColor"
          />
        </svg>
      </Icon>
    ),
    title: "money",
    name: "money",
  },
  {
    icon: (
      <Icon
      viewBox="0 0 16 16"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 0C3.5625 0 0 3.59375 0 8C0 12.4375 3.5625 16 8 16C12.4062 16 16 12.4375 16 8C16 3.59375 12.4062 0 8 0ZM14.5 8C14.5 9.28125 14.125 10.4688 13.5 11.4688L8.75 7.65625V1.5625C11.9688 1.9375 14.5 4.6875 14.5 8ZM7.25 14.4688C5.75 14.3125 4.4375 13.625 3.40625 12.625L7.25 9.5625V14.4688ZM8.75 9.5625L12.5625 12.625C11.5312 13.625 10.2188 14.2812 8.75 14.4688V9.5625ZM7.25 1.5625V7.65625L2.46875 11.4688C1.84375 10.4688 1.5 9.28125 1.5 8C1.5 4.6875 4 1.9375 7.25 1.5625Z"
            fill="currentColor"
          />
        </svg>
      </Icon>
    ),
    title: "peace",
    name: "peace",
  },
  {
    icon: (
      <Icon
      viewBox="0 0 18 18"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.75 5.5C13.75 6.21875 13.1875 6.75 12.5 6.75C11.7812 6.75 11.25 6.21875 11.25 5.5C11.25 4.8125 11.7812 4.25 12.5 4.25C13.1875 4.25 13.75 4.8125 13.75 5.5ZM1.71875 10C1.46875 10 1.21875 9.875 1.09375 9.625C0.9375 9.40625 0.9375 9.125 1.09375 8.875L2.71875 6.125C3.125 5.4375 3.875 5 4.65625 5H7.21875C7.3125 4.875 7.375 4.78125 7.46875 4.65625C10.0312 0.875 13.8438 0.75 16.0938 1.1875C16.4688 1.25 16.75 1.53125 16.8125 1.90625C17.25 4.15625 17.125 7.96875 13.3438 10.5312C13.2188 10.625 13.0938 10.6875 13 10.7812V13.3438C13 14.125 12.5625 14.875 11.875 15.2812L9.125 16.9062C8.875 17.0312 8.59375 17.0625 8.375 16.9062C8.125 16.7812 7.96875 16.5312 7.96875 16.25V13.25C7.71875 13.375 7.46875 13.4688 7.25 13.5625C6.90625 13.7188 6.46875 13.625 6.1875 13.3438L4.59375 11.7812C4.3125 11.4688 4.21875 11.0625 4.40625 10.6875C4.46875 10.5 4.5625 10.25 4.6875 10H1.71875ZM15.4062 2.59375C13.4375 2.3125 10.6562 2.625 8.6875 5.5C7.75 6.90625 6.5625 9.5 5.90625 10.9688L7 12.0625C8.46875 11.4375 11.0938 10.25 12.5 9.28125C15.375 7.34375 15.6875 4.5625 15.4062 2.59375Z"
            fill="currentColor"
          />
        </svg>
      </Icon>
    ),
    title: "self improvement",
    name: "self improvement",
  },
  {
    icon: (
      <Icon
      viewBox="0 0 20 14"
      >
        <svg
          width="20"
          height="14"
          viewBox="0 0 20 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.25 10H0.75C0.3125 10 0 10.3438 0 10.75V11.25C0 12.7812 1.21875 14 2.75 14H17.25C18.75 14 20 12.7812 20 11.25V10.75C20 10.3438 19.6562 10 19.25 10ZM17.25 12.5H2.75C2.125 12.5 1.625 12.0938 1.5 11.5H18.4688C18.3438 12.0938 17.8438 12.5 17.25 12.5ZM3.5 1.75C3.5 1.625 3.59375 1.5 3.75 1.5H16.25C16.375 1.5 16.5 1.625 16.5 1.75V9H18V1.75C18 0.8125 17.1875 0 16.25 0H3.75C2.78125 0 2 0.8125 2 1.75V9H3.5V1.75Z"
            fill="currentColor"
          />
        </svg>
      </Icon>
    ),
    title: "work",
    name: "work",
  },
];

let tabs = [
  "picks",
  "collections",
  "evergreen",
  "customai",
];

const Collections = ({query}) => {

  // const { data: swrData } = useSWR("/api/auth/session", async (url) => {
  //   const res = await fetch(url);
  //   if (!res.ok) {
  //     throw new Error();
  //   }
  //   return res.json();
  // });

  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"


  const router = useRouter();
  const isAuthenticated = useFirebaseUser();
  const [savedTweet, setSavedTweet] = React.useState([]);
  const [tweets, setTweets] = React.useState([]);
  const [category, setCategory] = React.useState<any>("");
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { isOpen: isOpenShare, onOpen: onOpenShare, onClose: onCloseShare } = useDisclosure();
  const initialRef = React.useRef<any>();

  const [refresh, refresher] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedListId, setSelectedListId] = React.useState(0);
  const [tabId, setTabId] = React.useState(0);
  const [lists, setLists] = React.useState<any[]>([]);
  const [firstLoadDone, setFirstLoadDone] = React.useState(false);
  const cancelRef = React.useRef() as React.MutableRefObject<HTMLButtonElement>;
  const [isOpenDelete, setIsOpenDelete] = React.useState(false);
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false)
  const onCloseDelete = () => setIsOpenDelete(false);
  const mainContext: any = useContext(MainContext);

  //@ts-ignore
  const { isOpen: isEditOpen, onOpen: onEditOpen, onClose: onEditClose } = useDisclosure();
  const [isUpdate, setIsUpdate] = React.useState(false);

  const refreshPage = async () => {
    // await mutate("/api/auth/session");
    refresher({});
  }
  
  const getSavedTweets = async () => {
    // console.log("getSavedTweets");
    // console.log(loading);
    if (isAuthenticated) {
      setIsLoading(true);
      //@ts-ignore
      const resTweets = await getList(getAccount(session).id, selectedListId, false);
      //@ts-ignore
      // const ids = savedTweets.map((tweet) => tweet.id_str);
      setTweets(resTweets);
      
      //@ts-ignore
      setSavedTweet(resTweets);
      setIsLoading(false);
    }
  };

  const getStaticCollection = async (category) => {

    setIsLoading(true);

    let cat = category.name;

    if (cat == "all")
      cat = "";

    setCategory(category);
    let tweets = await getCollection(cat);
    // console.log("nb tweets: " + tweets.length);
    setTweets(tweets);
    setIsLoading(false);
  }

  // React.useEffect(() => {
  //   // console.log("swrData: " + swrData?.user?.data?.lists);
  //   if (swrData?.user?.data?.lists)
  //     setLists(swrData?.user.data.lists);
  // }, [swrData]);

  useEffect(() => {
    // console.log("useEffect");
    if (isAuthenticated) {
      // console.log("lists: " + getAccount(session).lists);
      setLists(getAccount(session)?.lists ?? []);
    }
  }, [refresh, session, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && tabId == 1) {
      getSavedTweets();
    }
  }, [refresh, selectedListId]);


  const changeTabFromQuery = (query) => {
    if (query.tab) {
      let match = tabs.find(x => x == query.tab);
      if (match)
      {
        let index = tabs.indexOf(match);
        setTabId(index);
      }
    }
  }

  useEffect(() => {
    changeTabFromQuery(query);
  }, []);

  useEffect(() => {
    console.log("change tab to: " + query.tab);
    changeTabFromQuery(query);
  }, [query.tab]);

  useEffect(() => {
    if (isAuthenticated && !firstLoadDone) {
      setFirstLoadDone(true);
      // console.log("tabId: " + tabId);
      if (tabId == 1) {
        loadPersonalCollections();
      }
    }
  }, [session, isAuthenticated]);

  const loadStaffPick = () => {
    
    setTweets([]);
    setIsLoading(false);
    
  }

  const loadPersonalCollections = () => {

    getSavedTweets();
    analytics.log("saved_post_viewed");
  }

  let publicUrl = selectedListId !== undefined ? "https://taplio.com/collection?id=" + getAccount(session)?.id
    + "&idList=" + selectedListId
    + "&list=" + encodeURIComponent(getAccount(session)?.lists.find(x => x.id === selectedListId)?.name)
    + "&handle=" + encodeURIComponent(getAccount(session)?.username)
    + "&name=" + encodeURIComponent(getAccount(session)?.name) : "";

    const tweetContext: any = useContext(TweetContext);
  
  
  if (!loading && !session) {
    return <ProtectedRoute />;
  }

  return (
    <Page
      {...{
        title: "Collections",
    }}
    >
        {/* <Heading variant={variant.Heading.pageTitle} as="h1">
          Collections
        </Heading> */}
        <Tabs
          // variant="unstyled"
          index={tabId}
          onChange={(index) => {
            // console.log("tabs change to " + index);
            if (index == 0) {
              loadStaffPick();
            } else if (index == 1) {
              loadPersonalCollections();
            }
            setInLocalStorage("collectionTabId", "" + index);
            setTabId(index);
            router.push(
              {
                pathname: "/collections",
                query: { tab: tabs[index] },
              },
              undefined,
              { shallow: false }
            );
          }}
        >
          <TabList
            mt={5}
            // ml={4} mt={4} mb={4} p={0}
          >
            <Tab
              _focus={{ boxShadow: "none" }}
              // _selected={selectedTabStyle}
              p={0}
              mr={6}
            >
              <Box mb={2}>Staff Picks</Box>
            </Tab>
            <Tab
              _focus={{ boxShadow: "none" }}
              // _selected={selectedTabStyle}
              p={0}
              mr={6}
            >
              <Box mb={2}>My Collections</Box>
            </Tab>
            {/* <Tab _focus={{ boxShadow: 'none' }} _selected={selectedTabStyle} p={0} mr={6}>
              <Box mb={2}>
                Evergreen 🌲
              </Box>
            </Tab> */}
            {/* <Tab _focus={{ boxShadow: 'none' }} _selected={selectedTabStyle} p={0} mr={6}>
              <Box mb={2}>
                Custom AI 🤖
              </Box>
            </Tab> */}
          </TabList>

          <TabPanels>
            <TabPanel pt={6} maxW="1000px" gap={6} margin={"auto"}>
              <Text
                textStyle={textStyle["body.medium.light"]}
                color={useColorModeValue("gray.600", "gray.300")}
              >
                10,000+ best-in-class posts curated by professional marketers.
                Updated daily.
              </Text>

              <Wrap
                mb={0}
                mt={6}
                width="100%"
                justify="flex-start"
                // spacing="16px"
              >
                {staticCollections.map((cat: any) => (
                  <Button
                    key={cat.title}
                    // bg={cat.name == category.name ? "blue.700" : "blue.100"}
                    // color={cat.name === category.name ? "white" : "#1E1E1E"}
                    // _hover={{ bg: "blue.200" }}
                    // size="xs"
                    // borderRadius="10"
                    // fontWeight="400"
                    {...{
                      // values from secondary
                      color:
                        cat.name === category.name
                          ? "white"
                          : color["text.lightMode.standard"],
                      bg:
                        cat.name == category.name
                          ? color["primary.lightMode.default"]
                          : undefined,
                      _dark: {
                        color:
                          cat.name === category.name
                            ? "white"
                            : "text.darkMode.standard",
                        borderColor: "border.darkMode.light",
                        background:
                          cat.name == category.name
                            ? "primary.darkMode.default"
                            : "#1E1E1E",
                        _hover: {
                          borderColor: "border.darkMode.hover",
                          background: "#1E1E1E",
                        },
                        _active: {
                          color: "primary.darkMode.400",
                        },
                        _disabled: {
                          color: "text.darkMode.inactive",
                          borderColor: "border.darkMode.inactive",
                          _hover: {
                            borderColor: "border.darkMode.hover",
                          },
                        },
                      },
                    }}
                    variant={variant.Button.secondary}
                    borderRadius="full"
                    onClick={async () => {
                      await getStaticCollection(cat);
                    }}
                    leftIcon={cat.icon}
                  >
                    {cat.title}
                  </Button>
                ))}
              </Wrap>

              {isLoading ? (
                <Center pt={10}>
                  <PuffLoader
                    color={"#0A66C2"}
                    loading={isLoading}
                    cssOverride={{
                      display: "block",
                      margin: "0 auto",
                      borderColor: "red",
                    }}
                    size={50}
                  />
                </Center>
              ) : tweets.length > 0 && !loading ? (
                <>
                    {/* <Center> */}
                    <Grid {...{flex: 1, mt: 6, w: "full", placeItems: "flex-end"}}>

                    <Button
                      rightIcon={
                        <Icon viewBox="0 0 17 15">
                          <svg
                            width="17"
                            height="15"
                            viewBox="0 0 17 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.25 8.46875C12.9375 8.1875 12.4688 8.1875 12.1875 8.5C11.875 8.78125 11.875 9.25 12.1875 9.53125L13.4375 10.75H10.375L8.53125 8.34375L7.625 9.59375L9.40625 11.9688C9.53125 12.1562 9.75 12.25 10 12.25H13.4375L12.2188 13.5C11.9062 13.7812 11.9062 14.25 12.2188 14.5312C12.3438 14.6875 12.5312 14.75 12.75 14.75C12.9375 14.75 13.125 14.6875 13.25 14.5312L15.75 12.0312C16.0312 11.75 16.0312 11.2812 15.75 10.9688L13.25 8.46875ZM0.75 4.25H3.625L5.4375 6.6875L6.34375 5.4375L4.59375 3.0625C4.4375 2.875 4.21875 2.75 4 2.75H0.75C0.3125 2.75 0 3.09375 0 3.5C0 3.9375 0.3125 4.25 0.75 4.25ZM13.4375 4.25L12.2188 5.5C11.9062 5.78125 11.9062 6.25 12.2188 6.53125C12.3438 6.6875 12.5312 6.75 12.75 6.75C12.9375 6.75 13.125 6.6875 13.25 6.53125L15.75 4.0625C16.0312 3.75 16.0312 3.28125 15.75 3L13.25 0.5C12.9688 0.1875 12.5 0.1875 12.2188 0.5C11.9062 0.78125 11.9062 1.25 12.2188 1.53125L13.4375 2.75H10C9.75 2.75 9.53125 2.875 9.375 3.0625L3.625 10.75H0.75C0.3125 10.75 0 11.0938 0 11.5C0 11.9375 0.3125 12.25 0.75 12.25H4C4.21875 12.25 4.4375 12.1562 4.59375 11.9688L10.375 4.25H13.4375Z"
                              fill="currentColor"
                            />
                          </svg>
                        </Icon>
                      }
                      variant="secondary"
                      // size="sm"
                      // m={5}
                      // _hover={{ bg: "blue.50" }}
                      onClick={async () => {
                        await getStaticCollection(category);
                      }}
                    >
                      Shuffle
                    </Button>
                    </Grid>
                  {/* </Center> */}
                  <Tweets
                    savedTweet={savedTweet}
                    tweets={tweets}
                    refresher={refreshPage}
                    refresh={refresh}
                    disableHideButton={true}
                    disableSaveCsv={true}
                    disableEmbed={true}
                  />
                </>
              ) : (
                <Center mt={20}>
                  <Stack>
                    <Heading
                      textAlign="center"
                      fontSize="xl"
                      fontWeight={500}
                      maxW={350}
                    >
                      Pick a category 👆
                    </Heading>
                  </Stack>
                </Center>
              )}
            </TabPanel>
            <TabPanel pt={6} maxW="1000px">
              <Grid
                // mt={6}
                // mb={6}
                // templateRows="repeat(2, 1fr)"
                // templateColumns="repeat(6, 1fr)"
                // templateColumns="repeat(1, 1fr)"
                templateColumns={{ md: "repeat(6, 1fr)", sm: "repeat(3, 1fr)" }}
                // templateColumns={{sm: 2, md: 2}}
                columnGap="0"
                rowGap={5}
                maxW="1000px"
                margin={"auto"}
              >
                <GridItem colSpan={3} display="flex">
                  <Menu isLazy variant={variant.Menu.secondary}>
                    <MenuButton
                      as={Button}
                      // size="sm"
                      variant="secondary"
                      rightIcon={<ChevronDownIcon />}
                    >
                      <Text
                        // textStyle={textStyle["body.medium.light"]}
                        noOfLines={1}
                        wordBreak={"break-all"}
                      >
                        {!selectedListId
                          ? "All my saved posts"
                          : lists.find((l) => l.id == selectedListId)?.name}
                      </Text>
                    </MenuButton>
                    <MenuList maxH="215px" overflow="scroll">
                      <MenuItem
                        width="100%"
                        justifyContent="space-between"
                        alignItems="center"
                        cursor="default"
                      >
                        <Text
                          textStyle={textStyle["body.medium.light"]}
                          width="90%"
                          onClick={(e) => setSelectedListId(0)}
                        >
                          All my saved posts
                        </Text>
                      </MenuItem>
                      {lists?.length > 0 ? (
                        lists.map((list, index) => (
                          <MenuItem
                            width="100%"
                            justifyContent="space-between"
                            alignItems="center"
                            cursor="default"
                            key={index}
                          >
                            <Text
                              textStyle={textStyle["body.medium.light"]}
                              width="90%"
                              onClick={(e) =>
                                setSelectedListId(parseInt(list.id))
                              }
                            >
                              {list.name}
                            </Text>
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem
                          width="100%"
                          justifyContent="space-between"
                          alignItems="center"
                          cursor="default"
                        >
                          <Text textStyle={textStyle["body.medium.light"]}>
                            No List found
                          </Text>
                        </MenuItem>
                      )}
                    </MenuList>
                  </Menu>
                  <IconButton
                    aria-label="update-collection"
                    variant="secondary"
                    size="md"
                    onClick={async () => {
                      console.log("selectedList: " + selectedListId);
                      setIsUpdate(false);
                      onEditOpen();
                    }}
                    icon={<AddIcon />}
                    mr={0}
                    ml="2"
                  />
                  {selectedListId && selectedListId > 0 ? (
                    <>
                      <IconButton
                        aria-label="update-collection"
                        variant="ghost"
                        size="md"
                        onClick={async () => {
                          console.log("selectedList: " + selectedListId);
                          setIsUpdate(true);
                          onEditOpen();
                        }}
                        icon={<EditIcon />}
                        mr={0}
                      />
                      <IconButton
                        aria-label="update-collection"
                        variant="ghost"
                        size="md"
                        onClick={async () => {
                          console.log("deleteList: " + selectedListId);
                          setIsOpenDelete(true);
                        }}
                        icon={<DeleteIcon />}
                        mr={1}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </GridItem>
                <GridItem
                  colSpan={3}
                  display="flex"
                  justifyContent={{ md: "flex-end", sm: "flex-start" }}
                >
                  <Button
                    // mt={1}
                    // ml={0}
                    mr={2}
                    onClick={() => {
                      if (getAccount(session)?.idLinkedin) {
                        onOpen();
                      } else {
                        mainContext.onOpenGetExtension();
                      }
                    }}
                    variant="secondary"
                    isDisabled={selectedListId === 0} // dont allow imports in "Allow my saved posts" menu. It is suppose to just show posts from all collections
                    // bg="blue.50"
                    // color="gray.800"
                    // _hover={{ bg: "blue.100" }}
                  >
                    Import Posts
                  </Button>
                  {isAuthenticated && (
                    <CopyToClipboard
                      text={publicUrl}
                      onCopy={() => {
                        toast.success("Public URL copied to clipboard", {
                          style: {
                            background: "gray.600",
                            color: "#222",
                          },
                        });
                      }}
                    >
                      <Button
                        variant="secondary"
                        // mt={1}
                        //     ml={4}
                        onClick={(e) => {
                          onOpenShare();
                        }}
                        // colorScheme="blue"
                        // bg="blue.700"
                        // color="white"
                        // _hover={{ bg: "blue.600" }}
                      >
                        Share Public Url
                      </Button>
                    </CopyToClipboard>
                  )}
                </GridItem>
              </Grid>
              <Grid mt={5}>
                {isLoading ? (
                  <Center pt={10}>
                    <PuffLoader
                      color={"#0A66C2"}
                      loading={isLoading}
                      cssOverride={{
                        display: "block",
                        margin: "0 auto",
                        borderColor: "red",
                      }}
                      size={50}
                    />
                  </Center>
                ) : tweets.length > 0 && !loading ? (
                  <Tweets
                    savedTweet={savedTweet}
                    tweets={tweets}
                    refresher={refreshPage}
                    refresh={refresh}
                    disableHideButton={true}
                    //@ts-ignore
                    embedData={{
                      id: getAccount(session).id,
                      idList: selectedListId,
                    }}
                  />
                ) : (
                  <Center mt={4}>
                    <Stack>
                      <Text
                        textStyle={textStyle["h4.bold.standard"]}
                        textAlign="center"
                        // fontSize="xl"
                        // fontWeight={500}
                        maxW={300}
                      >
                        You haven’t saved any posts yet. Save posts from your
                        searches on Taplio and they will appear here.
                      </Text>
                      <Text
                        textStyle={textStyle["body.medium.light"]}
                        textAlign="center"
                        fontSize={30}
                      >
                        💾
                      </Text>
                    </Stack>
                  </Center>
                )}
              </Grid>
            </TabPanel>
            {/* <TabPanel>
              <Evergreen/>
            </TabPanel> */}
            {/* <TabPanel>
              <CustomAi/>
            </TabPanel> */}
          </TabPanels>
        </Tabs>
      <ImportTweet
        isOpen={isOpen}
        onClose={onClose}
        refresher={refresher}
        selectedListId={selectedListId}
      />
      {
        // selectedListId ? (
        true ? (
          <UpsertCollection
            isUpdate={isUpdate}
            id={selectedListId}
            name={
              getAccount(session)?.lists.find((x) => x.id === selectedListId)
                ?.name
            }
            isOpen={isEditOpen}
            onClose={onEditClose}
            refresher={refreshPage}
          />
        ) : (
          <></>
        )
      }
      <AlertDialog
        isOpen={isOpenDelete}
        //@ts-ignore
        leastDestructiveRef={cancelRef}
        onClose={onCloseDelete}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader
            // fontSize="lg" fontWeight="bold"
            >
              {/* <ModalInfoIcon /> */}
              Delete Collection
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                variant="tertiary"
                ref={cancelRef}
                onClick={onCloseDelete}
              >
                Cancel
              </Button>
              <Button
                variant="primaryDestructive"
                colorScheme="red"
                onClick={async () => {
                  setIsDeleting(true);
                  await deleteList(
                    getAccount(session).id,
                    selectedListId,
                    session
                  );
                  refresher({});
                  setSelectedListId(0);
                  // await mutate("/api/auth/session");
                  onCloseDelete();
                  setIsDeleting(false);
                }}
                ml={3}
                isLoading={isDeleting}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <Modal
        initialFocusRef={initialRef}
        isOpen={isOpenShare}
        onClose={onCloseShare}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {/* <ModalInfoIcon /> */}
            Share your collection
          </ModalHeader>
          <ModalCloseButton _hover={{ bg: "blue.50" }} />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Your custom link</FormLabel>
              <InputGroup size="md">
                <Input ref={initialRef} value={publicUrl}
                  textStyle={textStyle["body.medium.standard"]}
                  isDisabled
                  // variant="disabledReadable"
                />
                <InputRightAddon
                  p={0}
                  children={
                    <CopyToClipboard
                      text={publicUrl}
                      onCopy={() => {
                        toast.success("Public URL copied to clipboard", {
                          style: {
                            background: "gray.600",
                            color: "#222",
                          },
                        });
                      }}
                    >
                      <IconButton
                        aria-label="Copy"
                        _focus={{ boxShadow: "none" }}
                        size="md"
                        variant="invisible"
                        icon={<BiCopy />}
                      />
                    </CopyToClipboard>
                  }
                />
              </InputGroup>
            </FormControl>
            {/* <Heading mt={8} size="small">
              Want to earn money by sharing it? 
            </Heading>
            <Text textStyle={textStyle["body.medium.light"]} mt={3}>
              Join our <Link href="https://tweethunter.getrewardful.com/" color="teal.500" isExternal>Referral Program</Link> and append this collection url with your custom parameter. 
            </Text>
            <Text textStyle={textStyle["body.medium.light"]} mt={3}>
              It should look like this: 
              <Code as="span"  ml={2} mr={2}>
                {"&via=YOUR_REFERRAL_ID"}
              </Code>
            </Text>
            <Text textStyle={textStyle["body.medium.light"]} mt={3}>
              You will receive a <b>30% commission</b> everytime a user you referred makes a payment, forever.
            </Text> */}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Page>
  );
};

Collections.getInitialProps = async ({query}) => {
  // console.log(query);
  return {query};
}

export default Collections;
